module.exports = __webpack_public_path__ + "static/Advantage05@3x.c4a65610.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage05@3x.png
// module id = 697
// module chunks = 216210090109534